import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGeneralAttachmentsStore,
	TGeneralAttachmentsListRequest,
	TGeneralAttachmentsListResponsePayload,
	TGeneralAttachmentCreateRequest,
	TGeneralAttachmentUpdateRequest,
	TGeneralAttachmentDownloadRequest,
	TGeneralAttachmentDeleteRequest,
	TGeneralAttachmentAddVersionRequest,
} from './types';

const initialState: TGeneralAttachmentsStore = {
	generalAttachments: null,
	generalAttachmentsLoading: false,
	createLoading: false,
	updateLoading: false,
	downloadLoading: false,
	deleteLoading: false,
	addVersionLoading: false,
};

const generalAttachments = createSlice({
	name: '@@generalAttachments',
	initialState,
	reducers: {
		getGeneralAttachmentsRequest: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentsListRequest>,
		) => {
			const s = state;
			s.generalAttachmentsLoading = true;
		},
		getGeneralAttachmentsSuccess: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentsListResponsePayload>,
		) => {
			const s = state;
			s.generalAttachments = action.payload;
			s.generalAttachmentsLoading = false;
		},

		createGeneralAttachmentRequest: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentCreateRequest>,
		) => {
			const s = state;
			s.createLoading = true;
		},
		createGeneralAttachmentSuccess: (state: TGeneralAttachmentsStore) => {
			const s = state;
			s.createLoading = false;
		},

		updateGeneralAttachmentRequest: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentUpdateRequest>,
		) => {
			const s = state;
			s.updateLoading = true;
		},
		updateGeneralAttachmentSuccess: (state: TGeneralAttachmentsStore) => {
			const s = state;
			s.updateLoading = false;
		},

		downloadGeneralAttachmentRequest: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentDownloadRequest>,
		) => {
			const s = state;
			s.downloadLoading = true;
		},
		downloadGeneralAttachmentSuccess: (state: TGeneralAttachmentsStore) => {
			const s = state;
			s.downloadLoading = false;
		},

		deleteGeneralAttachmentRequest: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentDeleteRequest>,
		) => {
			const s = state;
			s.deleteLoading = true;
		},
		deleteGeneralAttachmentSuccess: (state: TGeneralAttachmentsStore) => {
			const s = state;
			s.deleteLoading = false;
		},

		addGeneralAttachmentVersionRequest: (
			state: TGeneralAttachmentsStore,
			action: PayloadAction<TGeneralAttachmentAddVersionRequest>,
		) => {
			const s = state;
			s.addVersionLoading = true;
		},
		addGeneralAttachmentVersionSuccess: (state: TGeneralAttachmentsStore) => {
			const s = state;
			s.addVersionLoading = false;
		},
	},
});

export default generalAttachments.reducer;

export const {
	getGeneralAttachmentsRequest,
	getGeneralAttachmentsSuccess,
	createGeneralAttachmentRequest,
	createGeneralAttachmentSuccess,
	updateGeneralAttachmentRequest,
	updateGeneralAttachmentSuccess,
	downloadGeneralAttachmentRequest,
	downloadGeneralAttachmentSuccess,
	deleteGeneralAttachmentRequest,
	deleteGeneralAttachmentSuccess,
	addGeneralAttachmentVersionRequest,
	addGeneralAttachmentVersionSuccess,
} = generalAttachments.actions;
